<template>
	<header class="app-header navbar">
		<button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
			<span class="navbar-toggler-icon"></span>
		</button>
		<b-link class="navbar-brand" to="#"></b-link>
		<button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
			<span class="navbar-toggler-icon"></span>
		</button>
		<b-navbar-nav class="ml-auto">
			<b-nav-item class="d-md-down-none"><i class="icon-bell"></i><!--b-badge pill variant="danger">5</b-badge--></b-nav-item>
			<HeaderDropdown/>
		</b-navbar-nav>
		<button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
			<span class="navbar-toggler-icon"></span>
		</button>
	</header>
</template>

<script>
import HeaderDropdown from './HeaderDropdown.vue'
export default {
	name: 'c-header',
	components: {
		HeaderDropdown
	},
	methods: {
		sidebarToggle (e) {
			e.preventDefault()
			document.body.classList.toggle('sidebar-hidden')
		},
		sidebarMinimize (e) {
			e.preventDefault()
			document.body.classList.toggle('sidebar-minimized')
		},
		mobileSidebarToggle (e) {
			e.preventDefault()
			document.body.classList.toggle('sidebar-mobile-show')
		},
		asideToggle (e) {
			e.preventDefault()
			document.body.classList.toggle('aside-menu-hidden')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue